<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div v-if="imagenes.length === 0" class="text-center align-items-center flex--wrap" style=" display: grid; place-items: center; margin-top:4%;">
      <img width="130" src="../../assets/icons/no-result.png">
      <p class="txt-not-found text-center">No se encontraron herramientas</p>
    </div>
    <template v-else @click="irTabExpediente()">
      <b-carousel
          id="carousel-fade"
          controls
      >
        <b-carousel-slide v-for="(item,i) in imagenes" :key="'imagen-'+i">
          <template #img>

              <img
                      v-if="item.Name.includes('.jpg')"
                      class="d-block img-fluid w-100"
                      width="1024"
                      height="480"
                      :src="'data:image/jpg;base64, '+item.imagenBase64"
                      alt="image slot"
              >
              <pdf
                      v-else
                :page="1"
                :src="'data:application/pdf;base64,'+item.imagenBase64"
            ></pdf>
          </template>
        </b-carousel-slide>
      </b-carousel>
    </template>
  </div>
</template>

<script>
import pdf from "vue-pdf";

export default {
  name: "carruselHerramientas",
  props: {
    idPaciente: null
  },
  components: {
    pdf,
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      imagenes: []
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerImagenes()
  },
  methods: {
    obtenerImagenes() {
      const params = {
        idPaciente: this.idPaciente
      }
      this.$http
          .post(
              this.$api +
              "sharepoint/obtener/carrusel", params)
          .then((response) => {
            this.imagenes = response.data.data;
          })
    },
    irTabExpediente() {
      this.$emit('irTabExpediente')
    }
  }
}
</script>

<style scoped>

</style>